namespace RedBullMOBILE360.Sms {
    export namespace CampaignEligibilityService {
        export const baseUrl = 'Sms/CampaignEligibility';

        export declare function Create(request: Serenity.SaveRequest<CampaignEligibilityRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CampaignEligibilityRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CampaignEligibilityRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CampaignEligibilityRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Sms/CampaignEligibility/Create",
            Update = "Sms/CampaignEligibility/Update",
            Delete = "Sms/CampaignEligibility/Delete",
            Retrieve = "Sms/CampaignEligibility/Retrieve",
            List = "Sms/CampaignEligibility/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>CampaignEligibilityService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
